<template>
    <div class="order-basket">
        <div class="loader" v-show="processing"></div>
        <div class="making_order">
            <div class="making_order__title">Оформление заказа</div>
            <div class="making_order__title--mobile">Ваш заказ</div>
            <basket-list :products="products" />
            <div class="making_order__paragraph"
                 v-if="isRelated">Не забудьте добавить</div>
            <product-slider
                :products="$root.basket.cart.related"
                v-if="isRelated"
            />
            <checkout ref="checkout" />
        </div>
        <div class="payment_method"
             :style="{'height': currentHeight}">
            <payment-method
                @getPayment="setPayment"
                @clearPromocode="$refs['checkout'].clearPromocode()"
                @clearUds="$refs['checkout'].clearUds()"
                @applyUds="$refs['checkout'].applyUds($event)"
                @applyPromocode="$refs['checkout'].applyPromocode($event)"
                @createOrder="$refs['checkout'].createOrder(true)"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        products: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            payment: null,
            scrollY: null,
            processing: false
        }
    },
    computed: {
        isRelated() {
            return Object.keys(this.$root.basket.cart.related).length > 0;
        },
        canOrderSubmit() {
            return this.$refs['checkout'].canOrderSubmit;
        },
        currentHeight() {
            let height = this.$root.orderType === 'delivery' ? 1395 : 1220;
            const countAll = this.$root.basket.cart.count;

            if (countAll > 1) {
                height = height + (160 * (countAll - 1));
            }

            if (this.$root.isChangeTotal) {
                height += 79;
            }

            return `${height}px`;
        }
    },
    methods: {
        setPayment(payment) {
            this.payment = payment;
        },
    },
    created() {
        this.$nextTick(() => {
            window.addEventListener('scroll', () => {
                this.scrollY = window.scrollY;
            });
        });
    }
}
</script>

<style scoped>
#app > .container {
    overflow: unset !important;
}
</style>
